import { Button, Card, Modal, Select } from "antd";

const AssignedCallDetails = ({ open, handleCancel, formData }) => {
  const fields = [
    { label: "Agent Name", value: formData?.originalItem?.agent_name },
    { label: "Call ID", value: formData?.originalItem?.call_id },
    { label: "Audit type", value: "Manual" }, // replace dynamically if needed
    {
      label: "Call duration",
      value: formData?.originalItem?.call_time || formData?.originalItem?.duration,
    },
    { label: "Disposition", value: formData?.originalItem?.disposition_name || "-" },
    // { label: "Call status", value: formData?.originalItem?.call_status },
    // {
    //   label: "Recording",
    //   value: (
    //     <a href={formData?.originalItem?.recording_url} target="_blank" rel="noreferrer">
    //       Play
    //     </a>
    //   ),
    // },
  ];

  return (
    <Modal
      title={
        <div className="container-fluid d-flex flex-column align-items-start text-start">
          <div className="d-flex flex-column mb-2 mt-3">
            <span className="fs-5 fw-semibold w-auto">Call Info</span>
            <span className="fs-6 fw-semibold text-muted w-auto">
              A quick overview to help guide your responses.
            </span>
          </div>
        </div>
      }
      open={open}
      onCancel={handleCancel}
      footer={null}
      width={500}
    >
      <Card style={{ width: "100%" }}>
        {fields.map((item, idx) => (
          <div
            key={idx}
            className="d-flex justify-content-between align-items-center border p-2 mb-2 rounded"
          >
            <span className="fw-bold">{item.label}</span>
            <span
              className="fw-semibold d-inline-block text-truncate"
              style={{ maxWidth: "200px" }}
              title={item.value}
            >
              {item.value}
            </span>
          </div>
        ))}
      </Card>
    </Modal>
  );
};

export default AssignedCallDetails;
